import React from 'react';
import FoodCalendar from '../Modules/Diary/Calendar';

function Diary() {
  return (
    <div>
      <FoodCalendar />
     </div>
  );
}

export default Diary;